export const IDEALIST_FOLLOW_KEY = 'idealistPreSignupFollow';
